import { Platform, useWindowDimensions } from "@-/com.npmjs.react-native";
import {
  SkeletonSurfaceHeader,
  SkeletonTileSurface,
} from "@-/dev.improve.haniverse.components.ui.skeleton";
import { BrowseFloatingToolbarSkeletonPage } from "#browse-floating-toolbar-skeleton-page";
import { useHasHydrated } from "@-/dev.improve.haniverse.lib.hydration";

/** Compound-count buckets: a 58px surface header with a title and primitive-count subtitle. */
export function BrowsePrimitivesListSkeleton() {
  const { width } = useWindowDimensions();
  const hasHydrated = useHasHydrated();
  // Mirrors the List page's column rule: eight on native, ~52px tiles (min six) on web.
  const columns =
    Platform.OS === "web" ? Math.max(6, Math.floor(((hasHydrated ? width : 0) - 4) / 52)) : 8;
  return (
    <BrowseFloatingToolbarSkeletonPage
      accessibilityLabel="Loading primitives"
      testID="browse-primitives-list-skeleton"
    >
      {[0, 1, 2, 3].map((key) => (
        <SkeletonTileSurface
          columns={columns}
          header={<SkeletonSurfaceHeader className="h-14.5 py-0" titleClassName="w-40" />}
          key={key}
        />
      ))}
    </BrowseFloatingToolbarSkeletonPage>
  );
}
